import React from "react";
import { useNavigate } from "react-router-dom";
import FrontendLayout from "../FrontendLayout";
import Distance from "../front-components/Distance";
import QuoteProgress from "../front-components/QuoteProgress";

export default function NewQuote() {
  const navigate = useNavigate();

  const getDistance = (data) => {   
    navigate("/distanceDetails", { state: { distanceDetails: data } });
  };

  return (
    <FrontendLayout>
      <main className="quote-flow-page">
        <div className="container quote-flow-container">
          <div className="quote-flow-heading wow fadeInUp" data-wow-delay="0.1s">
            <span className="quote-flow-eyebrow">
              <i className="fa fa-bolt"></i> Instant transport estimate
            </span>
            <h1>Plan your shipment</h1>
            <p>
              Enter your route to get a clear, distance-based quote in just a
              few steps.
            </p>
          </div>
          <QuoteProgress activeStep={1} />
          <Distance remitDistance={getDistance} />
        </div>
      </main>
    </FrontendLayout>
  );
}
